import { Upstream } from '@/infrastructure/network/Upstream/schema'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'
import { IQueryProps } from '@/entities/Upstream/Query'

export class GetRecruitment implements APIRequest<Upstream.Recruitment.GetRecruitmentResponse> {
  response: Upstream.Recruitment.GetRecruitmentResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(id: string) {
    this.path = `/recruitments/${id}`
  }
}

export class FetchRecruitment implements APIRequest<Upstream.Recruitment.FetchRecruitmentResponse> {
  response: Upstream.Recruitment.FetchRecruitmentResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: IQueryProps
  constructor(query?: IQueryProps) {
    this.params = query
    this.path = `/recruitments`
  }
}
